import styled from 'styled-components/macro';

export const PolicyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PolicyTitle = styled.h1`
  font-size: 2.5rem;
  line-height: 3.1rem;
  color: #001758;
  font-family: Lato-Light, sans-serif;
  font-weight: 300;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

export const PolicyDescription = styled.p`
  margin: 0 0 10px;
  font-family: Lato, serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
`;

export const PolicySeparationLine = styled.hr`
  width: 75%;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  border-top: 1px solid #eee;
`;

export const FormRow = styled.div`
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  flex-basis: 100%;
  flex: 1;
  height: 100%;
  margin: 0;
`;

export const MainFormColumn = styled(FormColumn)`
  margin: 10px;
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
`;
